// automatically generated by the FlatBuffers compiler, do not modify

import { FirmwareVersionMessage } from "../controller-info/firmware-version-message";
import { FloorLabelMessage } from "../controller-info/floor-label-message";

export enum ElevatorControllerInfoContent {
	NONE = 0,
	FloorLabelMessage = 1,
	FirmwareVersionMessage = 2,
}

export function unionToElevatorControllerInfoContent(
	type: ElevatorControllerInfoContent,
	accessor: (obj: FirmwareVersionMessage | FloorLabelMessage) => FirmwareVersionMessage | FloorLabelMessage | null
): FirmwareVersionMessage | FloorLabelMessage | null {
	switch (ElevatorControllerInfoContent[type]) {
		case "NONE":
			return null;
		case "FloorLabelMessage":
			return accessor(new FloorLabelMessage())! as FloorLabelMessage;
		case "FirmwareVersionMessage":
			return accessor(new FirmwareVersionMessage())! as FirmwareVersionMessage;
		default:
			return null;
	}
}

export function unionListToElevatorControllerInfoContent(
	type: ElevatorControllerInfoContent,
	accessor: (
		index: number,
		obj: FirmwareVersionMessage | FloorLabelMessage
	) => FirmwareVersionMessage | FloorLabelMessage | null,
	index: number
): FirmwareVersionMessage | FloorLabelMessage | null {
	switch (ElevatorControllerInfoContent[type]) {
		case "NONE":
			return null;
		case "FloorLabelMessage":
			return accessor(index, new FloorLabelMessage())! as FloorLabelMessage;
		case "FirmwareVersionMessage":
			return accessor(index, new FirmwareVersionMessage())! as FirmwareVersionMessage;
		default:
			return null;
	}
}
